import colors from '../../_shared/colors';

export default {
  container: `
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    padding: 16px;
  `,
  titleRow: `
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 16px;
  `,
  title: `
    font-size: 32px;
    font-weight: 700;
    text-align: center;
    margin: 0;
    line-height: 1.2;
  `,
  refreshBtn: `
    position: absolute;
    right: 0;
  `,
  header: `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 12px;
    flex-wrap: wrap;
  `,
  headerLeft: `
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
  `,
  headerRight: `
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  `,
  headerActions: `
    display: flex;
    gap: 8px;
  `,
  exportBtn: `
    background-color: ${colors.highlight};
    color: white;
    border-color: ${colors.highlight};
    &:hover, &:focus {
      background-color: ${colors.highlight};
      color: white;
      opacity: 0.9;
      border-color: ${colors.highlight};
    }
  `,
  kpiRow: `
    margin-bottom: 20px;
  `,
  kpiCard: `
    text-align: center;
    height: 100%;
    .ant-card-body {
      padding: 16px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  `,
  kpiLabel: `
    font-size: 13px;
    color: rgba(0, 0, 0, 0.55);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
    min-height: 2.6em;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  kpiValue: `
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
  `,
  section: `
    margin-bottom: 20px;
  `,
  // Center the card title relative to the FULL card width. antd lays the
  // card head out as flex [title | extra], so a wide extra (the Returns
  // All/Customer Pickups/Returns Select + Show all checkbox) shrinks the
  // title area and the (inherited text-align: center) title drifts left of
  // the card's center — see Reconciliation/Rejection Returns Scheduled
  // (Danielle 2026-06-09). Absolutely position the title across the whole
  // head so every report section centers like the narrow-extra ones;
  // pointer-events pass through and the extra sits above it so the filter
  // Select and Show all checkbox stay fully clickable.
  sectionCenteredHead: `
    .ant-card-head-wrapper {
      position: relative;
    }
    .ant-card-head-title {
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      padding: 0;
      text-align: center;
      pointer-events: none;
    }
    .ant-card-extra {
      position: relative;
      z-index: 1;
      margin-left: auto;
    }
  `,
  routeChartWrap: `
    width: 100%;
    height: 320px;
  `,
  chartWrap: `
    width: 100%;
    height: 280px;
  `,
  chartScroll: `
    width: 100%;
    height: 280px;
    overflow-x: auto;
    overflow-y: hidden;
  `,
  chartInner: `
    height: 100%;
    min-width: 100%;
  `,
  orderLink: `
    color: ${colors.highlight};
    cursor: pointer;
    font-weight: 500;
    &:hover {
      color: ${colors.highlight};
      text-decoration: underline;
      opacity: 0.85;
    }
  `,
  dueCell: `
    background-color: #ffd6d6;
    font-weight: 600;
  `,
  // Card #242 — the "within 30 days" band on the Drivers widget. Same filled
  // pill shape as dueCell (which stays the "within 7 days / expired" red).
  warnCell: `
    background-color: #ffe6c2;
    font-weight: 600;
  `,
  bottomDateRow: `
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 12px;
  `,
  sectionBreak: `
    border: 0;
    border-top: 4px solid rgba(0, 0, 0, 0.85);
    margin: 32px 0 16px 0;
  `,
  smallDatePicker: `
    width: 240px;
    .ant-calendar-picker-input {
      font-size: 12px;
      height: 28px;
    }
  `,
  // Fixed-height scrollable container that fits ~5 small-size antd table rows
  // (header ~39px + 5 rows * ~33px ≈ 204px). Vertical scroll kicks in past the
  // first 5 rows; users toggle "Show all" via the section extra to remove the
  // cap entirely.
  reportScroll: `
    max-height: 204px;
    overflow-y: auto;
    overflow-x: auto;
    .ant-table-thead > tr > th,
    .ant-table-small .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,
    .ant-table .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
      position: sticky;
      top: 0;
      z-index: 2;
      background-color: #fafafa !important;
    }
    .ant-table-thead > tr > th::before,
    .ant-table-thead > tr > th::after {
      background-color: #fafafa !important;
    }
  `,
  reportScrollAll: `
    max-height: none;
    overflow-y: visible;
    overflow-x: auto;
  `,
  showAllToggle: `
    font-size: 12px;
  `,
  // Keep the License # column on one line on desktop (Danielle 2026-06-03);
  // allow wrapping below the antd md breakpoint (mobile), matching the
  // surrounding Col xs={24} md={12} layout.
  licenseNoWrap: `
    td.license-col, th.license-col {
      white-space: nowrap;
    }
    @media (max-width: 767px) {
      td.license-col, th.license-col {
        white-space: normal;
      }
    }
  `,
};
